export default __webpack_public_path__ + "static/media/france.0a00ceb7.svg";